export default __webpack_public_path__ + "static/media/assessment_result_info_icon.d18a82a2.svg";